export default "__VITE_ASSET__CT$RFhHf__"